// Intent: the daily forecast log behind "zobacz jak się przesuwał". Expenses
// are recomputable for any past day (entries carry real dates), but the
// FORECAST is not — so what the app predicted each day is recorded once per
// day and never reconstructed. Rows live in a LOCAL_ONLY table: this is a
// per-device observation log and deliberately never joins cloud/household sync.

import { create } from 'zustand';

import { getDb, LOCAL_ONLY_TABLES } from '@/db';
import type { ForecastSnapshot } from '@/types/domain';

interface ForecastHistoryState {
  hydrated: boolean;
  /** day ISO -> snapshot; id === day, so the map is the natural shape. */
  byDay: Record<string, ForecastSnapshot>;
  hydrate: () => Promise<void>;
  record: (snap: ForecastSnapshot) => Promise<void>;
}

export function snapshotFor(byDay: Record<string, ForecastSnapshot>, iso: string): ForecastSnapshot | null {
  return byDay[iso] ?? null;
}

export const useForecastHistoryStore = create<ForecastHistoryState>((set) => ({
  hydrated: false,
  byDay: {},

  hydrate: async () => {
    const db = await getDb();
    const rows = await db.list<ForecastSnapshot>(LOCAL_ONLY_TABLES.forecastSnapshots);
    const byDay: Record<string, ForecastSnapshot> = {};
    for (const row of rows) byDay[row.day] = row;
    set({ hydrated: true, byDay });
  },

  record: async (snap) => {
    const db = await getDb();
    await db.upsert(LOCAL_ONLY_TABLES.forecastSnapshots, snap.id, snap);
    set((s) => ({ byDay: { ...s.byDay, [snap.day]: snap } }));
  },
}));
